/**
 * Single source of truth for every price the frontend displays.
 *
 * Must be kept in lockstep with backend/pricing.py (the authoritative file
 * for what is actually charged and enforced) — there is no shared runtime,
 * so the pairing is maintained by hand. If a number here disagrees with
 * backend/pricing.py, the backend is right and this file is the bug.
 *
 * INR prices are regional pricing inclusive of 18% GST, not an FX
 * conversion of the USD price.
 */

// Only the one-time $49 STARTER audit is a real product (FREE gives the
// first one). PRO/MAX were removed on 2026-07-16 — see backend/pricing.py.
export const PLAN_PRICES = {
  // 'per month' from 2026-08-31, matching backend/pricing.py's monthly_audits.
  // The string is here so the four surfaces that show it cannot disagree.
  FREE: { usd: 0, inr: 0, quota: '1 audit per month' },
  STARTER: { usd: 49, inr: 1200, quota: 'per audit' },
};

/**
 * NON-SELF-SERVE TIERS. Marketing surface only — NOT plans.
 *
 * ── WHY THIS IS A SEPARATE CONSTANT ─────────────────────────────────────────
 *
 * Agency is fulfilled by hand. There is no recurring billing behind it: no
 * PayPal or Razorpay plan, no webhook, no subscription record, and crucially
 * NO ENTRY IN PLAN_LIMITS. It cannot be bought, so nothing enforces it.
 *
 * It is not in PLAN_PRICES above, and it is not in backend/pricing.py, because
 * `pricing.plan_limits()` iterates `PLANS.items()` unconditionally — adding
 * AGENCY there would mint a PLAN_LIMITS["AGENCY"] entry as a side effect and
 * put a tier nobody can buy into quota enforcement. The separation is the
 * whole point, not an oversight, and it is why the mirror-to-backend rule at
 * the top of this file does not apply to this constant.
 *
 * The price still lives HERE rather than in a component, so it is read and not
 * typed like every other figure on the site — src/__tests__/no-bare-price-literal
 * exempts this file and only this file.
 *
 * `quota` is the owner's stated cadence, not an enforced limit. Nothing checks
 * it; it describes what is fulfilled manually.
 */
export const CONTACT_TIERS = {
  AGENCY: { usd: 149, period: '/mo', quota: '1 audit per week' },
};

// Add-ons are one-time charges attached to an audit purchase, not recurring.
export const ADDON_PRICES = {
  white_label: { usd: 25, inr: 2500 },
  expert_call: { usd: 99, inr: 9500 },
};
